/** One entry of "Do zrobienia" as `GET /api/todo` gives it (module todo, F46). */
export type TodoItem = {
  id: string;
  module: string;
  kind: string;
  title: string;
  detail: string;
  link: string;
  dueDay: string | null;
  severity: 'info' | 'uwaga' | 'pilne';
};
export type TodoList = { items: TodoItem[]; count: number };

export const TODO_KEY = ['todo'] as const;

export const SEVERITY_LABELS: Record<TodoItem['severity'], string> = { pilne: 'Pilne', uwaga: 'Uwaga', info: 'Informacja' };
